import * as group from './group.json';
import * as breakdownDataSet from './breakdown.json';
import * as symbolMarks from './symbol.json';

export default [Object.assign({}, group, {
  data: (group['data'] || []).concat(
    breakdownDataSet
  ),
  marks: (group['marks'] || []).concat(
    symbolMarks
  )
})];



// WEBPACK FOOTER //
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/summary-nodes/symbol-group/index.ts